import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, Box } from '@material-ui/core';
import { inject, observer } from 'mobx-react';

import ScheduleLink from '../ScheduleLink';
import ScheduleModal from '../ScheduleModal';
import AssemblyStatusCard from '../AssemblyStatusCard';

import ModalStore from '../../stores/ModalStore';

import { productCardStyles } from './styles';

const ProductCard = props => {
  const { product, schedulingHistory } = props;

  const classes = productCardStyles(props);

  const handleViewDetailsClick = useCallback(
    event => {
      event.preventDefault();

      const { modalStore } = props;
      const { openModal } = modalStore;

      openModal();
    },
    [props]
  );

  return (
    <Grid item xs={12}>
      <Box display="flex" className={classes.card}>
        <Box>
          <img
            src={product.imageLink.replace('{w}x{h}', '540x540')}
            alt={product.description}
          />
        </Box>
        <Box flexDirection="column">
          <Typography className={classes.productTitle}>
            <b>{product.description}</b>
          </Typography>

          {schedulingHistory && (
            <>
              <ScheduleLink onClick={handleViewDetailsClick}>
                Ver detalhes
              </ScheduleLink>

              <ScheduleModal maxWidth="sm" title="Situação do agendamento">
                <Box>
                  <AssemblyStatusCard
                    type="warning"
                    updatedAt={schedulingHistory.date}
                    reason={schedulingHistory.reason}
                    description={schedulingHistory.description}
                  />
                </Box>
              </ScheduleModal>
            </>
          )}
        </Box>
      </Box>
    </Grid>
  );
};

ProductCard.propTypes = {
  product: PropTypes.object.isRequired,
  schedulingHistory: PropTypes.object,
  modalStore: PropTypes.instanceOf(ModalStore).isRequired,
};

ProductCard.defaultProps = {
  schedulingHistory: undefined,
};

export default inject('modalStore')(observer(ProductCard));
